import axiosInstance from "../service/api_service.js";
import ApiRoutes from "../utils/api_routes.js";

export const getAllAssignedProjects = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.assignedProjects, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getAllMyProjects = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.myProjects, {});
    console.log(response.data);
    
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const addReport = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.addReport, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getReport = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.getReport, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const applyLeave = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.applyLeave, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getMyLeaves = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.getLeave, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getTasks = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.getTasks, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};
export const getPendingTasks = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.getPendingTasks, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const updateTaskStatus = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.updateTaskStatus, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const addProject = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.addProject, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const updateProject = async (projectData) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.updateProject, projectData);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const deleteProject = async (projectid) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.deleteProject, { projectid });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getAllProjectsForAdmin = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.projectList, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const addModuleByEmployee = async (data) => {
  try {
    console.log(JSON.stringify(data));
    
    const response = await axiosInstance.post(ApiRoutes.addModule, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getAllModulesForAdmin = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.moduleList, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const updateModule = async (moduleData) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.updateModule, moduleData);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const deleteModule = async (moduleid, projectid) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.deleteModule, { moduleid, projectid });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getAllAssignmentsForAdmin = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.assignmentsList, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};
export const addAdditionalWorkReport = async (data) => {
  try {
    const response = await axiosInstance.post(
      ApiRoutes.addAdditionalReport,
      data,
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getAdditionalWorkReports = async () => {
  try {
    const response = await axiosInstance.post(
      ApiRoutes.getAdditionalReports,
      {},
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const addAssignment = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.addAssignment, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const updateAssignment = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.updateAssignment, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const deleteAssignment = async (assignmentid) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.deleteAssignment, { assignmentid });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getModulesByProject = async (projectid) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.projectModulesByProject, { projectid });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const addMeeting = async (data) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.addMeeting, data);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getMyMeetings = async () => {
  try {
    const response = await axiosInstance.post(ApiRoutes.getMeetings, {});
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};

export const getAllMeetingsForAdmin = async (filters) => {
  try {
    const response = await axiosInstance.post(ApiRoutes.adminMeetingsList, filters);
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? "Something went wrong");
  }
};
